import React from 'react';
import { personalInfo } from '../data/portfolioData';

const SocialMedia = () => {
  const socialLinks = [
    {
      name: 'Instagram',
      url: personalInfo.instagram,
      icon: (
        <svg className="w-12 h-12" fill="currentColor" viewBox="0 0 24 24">
          <path d="M7.8,2H16.2C19.4,2 22,4.6 22,7.8V16.2A5.8,5.8 0 0,1 16.2,22H7.8C4.6,22 2,19.4 2,16.2V7.8A5.8,5.8 0 0,1 7.8,2M7.6,4A3.6,3.6 0 0,0 4,7.6V16.4C4,18.39 5.61,20 7.6,20H16.4A3.6,3.6 0 0,0 20,16.4V7.6C20,5.61 18.39,4 16.4,4H7.6M17.25,5.5A1.25,1.25 0 0,1 18.5,6.75A1.25,1.25 0 0,1 17.25,8A1.25,1.25 0 0,1 16,6.75A1.25,1.25 0 0,1 17.25,5.5M12,7A5,5 0 0,1 17,12A5,5 0 0,1 12,17A5,5 0 0,1 7,12A5,5 0 0,1 12,7M12,9A3,3 0 0,0 9,12A3,3 0 0,0 12,15A3,3 0 0,0 15,12A3,3 0 0,0 12,9Z" />
        </svg>
      ),
      gradient: 'from-purple-600 to-pink-600',
      description: 'Follow my photography and daily moments'
    },
    {
      name: 'Twitter',
      url: personalInfo.twitter,
      icon: (
        <svg className="w-12 h-12" fill="currentColor" viewBox="0 0 24 24">
          <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
        </svg>
      ),
      gradient: 'from-sky-500 to-blue-600',
      description: 'Tech updates and quick thoughts'
    },
    {
      name: 'LinkedIn',
      url: personalInfo.linkedin,
      icon: (
        <svg className="w-12 h-12" fill="currentColor" viewBox="0 0 24 24">
          <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
        </svg>
      ),
      gradient: 'from-blue-700 to-cyan-600',
      description: 'Professional network and career updates'
    },
    {
      name: 'YouTube',
      url: personalInfo.youtube,
      icon: (
        <svg className="w-12 h-12" fill="currentColor" viewBox="0 0 24 24">
          <path d="M23.498 6.186a2.99 2.99 0 0 0-2.104-2.115C19.497 3.5 12 3.5 12 3.5s-7.497 0-9.394.571A2.99 2.99 0 0 0 .502 6.686C0 8.593 0 12 0 12s0 3.407.502 5.314a2.99 2.99 0 0 0 2.104 2.115C4.503 20 12 20 12 20s7.497 0 9.394-.571a2.99 2.99 0 0 0 2.104-2.115C24 15.407 24 12 24 12s0-3.407-.502-5.314zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
        </svg>
      ),
      gradient: 'from-red-600 to-rose-600',
      description: 'Tech tutorials and coding sessions'
    }
  ];

  return (
    <section id="social" className="py-20 bg-gradient-to-b from-white to-gray-50 dark:from-slate-950 dark:to-slate-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16 animate-fade-in">
          <h2 className="text-4xl md:text-5xl font-bold apple-gradient-text mb-4">
            Connect With Me
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-blue-600 to-teal-600 mx-auto rounded-full"></div>
          <p className="mt-4 text-gray-600 dark:text-slate-300 max-w-2xl mx-auto">
            Let's connect on social media and stay updated
          </p>
        </div>

        {/* Social Links */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 max-w-7xl mx-auto">
          {socialLinks.map((social, index) => (
            <a
              key={index}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`group relative bg-white dark:bg-slate-900 rounded-2xl p-8 shadow-xl border-2 border-gray-200 dark:border-slate-700 hover:border-transparent hover:shadow-2xl transition-all duration-300 transform hover:scale-105 overflow-hidden flex flex-col apple-reveal-scale stagger-${(index % 4) + 1} apple-card`}
            >
              {/* Gradient Background on Hover */}
              <div className={`absolute inset-0 bg-gradient-to-r ${social.gradient} opacity-0 group-hover:opacity-100 transition-opacity duration-300`}></div>

              {/* Content */}
              <div className="relative z-10 flex flex-col flex-1">
                <div className="flex items-center gap-6 mb-4">
                  {/* Icon */}
                  <div className={`text-gray-700 dark:text-slate-200 group-hover:text-white transition-colors duration-300`}>
                    {social.icon}
                  </div>

                  {/* Name */}
                  <div>
                    <h3 className="text-2xl font-bold text-gray-900 dark:text-slate-100 group-hover:text-white transition-colors duration-300">
                      {social.name}
                    </h3>
                    <p className="text-gray-600 dark:text-slate-300 group-hover:text-white/90 transition-colors duration-300 mt-1 text-justify">
                      {social.description}
                    </p>
                  </div>
                </div>

                {/* Arrow Icon */}
                <div className="flex justify-end mt-auto">
                  <svg
                    className="w-6 h-6 text-gray-400 dark:text-slate-400 group-hover:text-white transform group-hover:translate-x-2 transition-all duration-300"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                  </svg>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SocialMedia;
